/**
 * Check if a number is a power of two.
 * @param n - input number.
 */
export function isPowerOfTwo(n) {
    return n !== 0 && (n & (n - 1)) === 0;
}
//# sourceMappingURL=isPowerOfTwo.js.map